import React from 'react';
import { FormGroup } from '~/components/form';
import { useForm } from '~/hooks';


export const OwnerIndividual= (props) => {

    const {
        onOwnerIndividualChange,
        detailData
    } = props;

    const defaultState = {
        ownerFirstName: detailData? detailData.ownerFirstName : '',
        ownerMiddleName: detailData? detailData.ownerMiddleName : '',
        ownerLastName: detailData? detailData.ownerLastName : '',
        ownerSuffix: detailData? detailData.ownerSuffix : ''
    };

    const { state, fieldActions } = useForm({
        initialState: { ...defaultState },
        debug: true
    });
    return (
        <div className="row grid grid-cols-4 grid-flow-row gap-x-2 gap-y-4 text-sm mb-4">  
            <FormGroup
                label="First"
                required
                groupClassName="col-span-1"
                inputClassName="w-full border-1 border-gray-200 rounded bg-gray-50"
                path={'ownerFirstName'}
                maxLength={12}
                validator={value=> value.length < 12 ? true : state.values.ownerFirstName && 'Limit to 12 characters.'}
                value={state.values.ownerFirstName}
                error={state.errors.ownerFirstName}
                {...fieldActions}
                onChange={(value) => {
                    fieldActions.onChange(value, 'ownerFirstName');
                    onOwnerIndividualChange(state.values);
                }}
            />
            <FormGroup
                label="Middle"
                groupClassName="col-span-1"
                inputClassName="w-full border-1 border-gray-200 rounded bg-gray-50"
                path='ownerMiddleName'
                maxLength={12}
                validator={value=> value.length < 12 ? true : state.values.ownerMiddleName && 'Limit to 12 characters.'}
                value={state.values.ownerMiddleName}
                error={state.errors.ownerMiddleName}
                autoComplete='no'
                {...fieldActions}
                onChange={(value) => {
                    fieldActions.onChange(value, 'ownerMiddleName');
                    onOwnerIndividualChange(state.values);
                }}
            />
            <FormGroup
                label="Last"
                required
                groupClassName="col-span-1"
                inputClassName="w-full border-1 border-gray-200 rounded bg-gray-50"
                path='ownerLastName'
                maxLength={12}
                validator={value=> value.length < 12 ? true : state.values.ownerLastName && 'Limit to 12 characters.'}
                value={state.values.ownerLastName}
                error={state.errors.ownerLastName}
                autoComplete='no'
                {...fieldActions}
                onChange={(value) => {
                    fieldActions.onChange(value, 'ownerLastName');   
                    onOwnerIndividualChange(state.values);                 
                }}
            />
            <FormGroup
                label="Suffix"
                groupClassName="col-span-1"
                inputClassName="w-full border-1 border-gray-200 rounded bg-gray-50"
                path='ownerSuffix'
                maxLength={12}
                validator={value=> value.length < 12 ? true : state.values.ownerSuffix && 'Limit to 12 characters.'}
                value={state.values.ownerSuffix}
                error={state.errors.ownerSuffix}
                autoComplete='no'
                {...fieldActions}
                onChange={(value) => {
                    fieldActions.onChange(value, 'ownerSuffix');
                    onOwnerIndividualChange(state.values);
                }}
            />             
        </div>
    );
};


export default OwnerIndividual;
